// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon[data-v-b1c5a80f] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widget-custom[data-v-b1c5a80f] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-large);
  background-color: transparent;
  display: flex;
}
.widget-access[data-v-b1c5a80f] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-large);
  background-color: transparent;
  display: flex;
  padding: calc(var(--default-grid-baseline, 4px) * 3);
}
.widget-default[data-v-b1c5a80f] {
  width: 100%;
  margin: auto;
  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);
  margin-top: calc(var(--default-grid-baseline, 4px) * 3);
  overflow: hidden;
  border: 2px solid var(--color-border);
  border-radius: var(--border-radius-large);
  background-color: transparent;
  display: flex;
}
.widget-default--compact[data-v-b1c5a80f] {
  flex-direction: column;
}
.widget-default--compact .widget-default--image[data-v-b1c5a80f] {
  width: 100%;
  height: 150px;
}
.widget-default--compact .widget-default--details[data-v-b1c5a80f] {
  width: 100%;
  padding-top: calc(var(--default-grid-baseline, 4px) * 2);
  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);
}
.widget-default--compact .widget-default--description[data-v-b1c5a80f] {
  display: none;
}
.widget-default--image[data-v-b1c5a80f] {
  width: 40%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.widget-default--name[data-v-b1c5a80f] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
}
.widget-default--details[data-v-b1c5a80f] {
  padding: calc(var(--default-grid-baseline, 4px) * 3);
  width: 60%;
}
.widget-default--details p[data-v-b1c5a80f] {
  margin: 0;
  padding: 0;
}
.widget-default--description[data-v-b1c5a80f] {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.widget-default--link[data-v-b1c5a80f] {
  color: var(--color-text-maxcontrast);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.material-design-icon[data-v-bd1fbb02] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.widgets--list.icon-loading[data-v-bd1fbb02] {
  min-height: 44px;
}
.material-design-icon[data-v-5f33f45b] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.rich-text--wrapper[data-v-5f33f45b] {
  word-break: break-word;
  line-height: 1.5;
}
.rich-text--wrapper .rich-text--fallback[data-v-5f33f45b],
.rich-text--wrapper .rich-text-component[data-v-5f33f45b] {
  display: inline;
}
.rich-text--wrapper .rich-text--external-link[data-v-5f33f45b] {
  text-decoration: underline;
}
.rich-text--wrapper .rich-text--external-link[data-v-5f33f45b]:after {
  content: " ↗";
}
.rich-text--wrapper .rich-text--ordered-list .rich-text--list-item[data-v-5f33f45b] {
  list-style: decimal;
}
.rich-text--wrapper .rich-text--un-ordered-list .rich-text--list-item[data-v-5f33f45b] {
  list-style: initial;
}
.rich-text--wrapper .rich-text--list-item[data-v-5f33f45b] {
  white-space: initial;
  color: var(--color-text-light);
  padding: initial;
  margin-left: 20px;
}
.rich-text--wrapper .rich-text--list-item.task-list-item[data-v-5f33f45b] {
  list-style: none;
  white-space: initial;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--list-item.task-list-item input[data-v-5f33f45b] {
  min-height: initial;
}
.rich-text--wrapper .rich-text--strong[data-v-5f33f45b] {
  white-space: initial;
  font-weight: 700;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--italic[data-v-5f33f45b] {
  white-space: initial;
  font-style: italic;
  color: var(--color-text-light);
}
.rich-text--wrapper .rich-text--heading[data-v-5f33f45b] {
  white-space: initial;
  font-size: initial;
  color: var(--color-text-light);
  margin-bottom: 5px;
  margin-top: 5px;
  font-weight: 700;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-1[data-v-5f33f45b] {
  font-size: 20px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-2[data-v-5f33f45b] {
  font-size: 19px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-3[data-v-5f33f45b] {
  font-size: 18px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-4[data-v-5f33f45b] {
  font-size: 17px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-5[data-v-5f33f45b] {
  font-size: 16px;
}
.rich-text--wrapper .rich-text--heading.rich-text--heading-6[data-v-5f33f45b] {
  font-size: 15px;
}
.rich-text--wrapper .rich-text--hr[data-v-5f33f45b] {
  border-top: 1px solid var(--color-border-dark);
  border-bottom: 0;
}
.rich-text--wrapper .rich-text--pre[data-v-5f33f45b] {
  border: 1px solid var(--color-border-dark);
  background-color: var(--color-background-dark);
  padding: 5px;
}
.rich-text--wrapper .rich-text--code[data-v-5f33f45b] {
  background-color: var(--color-background-dark);
}
.rich-text--wrapper .rich-text--blockquote[data-v-5f33f45b] {
  border-left: 3px solid var(--color-border-dark);
  padding-left: 5px;
}
.rich-text--wrapper .rich-text--table[data-v-5f33f45b] {
  border-collapse: collapse;
}
.rich-text--wrapper .rich-text--table thead tr th[data-v-5f33f45b] {
  border: 1px solid var(--color-border-dark);
  font-weight: 700;
  padding: 6px 13px;
}
.rich-text--wrapper .rich-text--table tbody tr td[data-v-5f33f45b] {
  border: 1px solid var(--color-border-dark);
  padding: 6px 13px;
}
.rich-text--wrapper .rich-text--table tbody tr[data-v-5f33f45b]:nth-child(even) {
  background-color: var(--color-background-dark);
}
.rich-text--wrapper-markdown div > *[data-v-5f33f45b]:first-child,
.rich-text--wrapper-markdown blockquote > *[data-v-5f33f45b]:first-child {
  margin-top: 0 !important;
}
.rich-text--wrapper-markdown div > *[data-v-5f33f45b]:last-child,
.rich-text--wrapper-markdown blockquote > *[data-v-5f33f45b]:last-child {
  margin-bottom: 0 !important;
}
.rich-text--wrapper-markdown h1[data-v-5f33f45b],
.rich-text--wrapper-markdown h2[data-v-5f33f45b],
.rich-text--wrapper-markdown h3[data-v-5f33f45b],
.rich-text--wrapper-markdown h4[data-v-5f33f45b],
.rich-text--wrapper-markdown h5[data-v-5f33f45b],
.rich-text--wrapper-markdown h6[data-v-5f33f45b],
.rich-text--wrapper-markdown p[data-v-5f33f45b],
.rich-text--wrapper-markdown ul[data-v-5f33f45b],
.rich-text--wrapper-markdown ol[data-v-5f33f45b],
.rich-text--wrapper-markdown blockquote[data-v-5f33f45b],
.rich-text--wrapper-markdown pre[data-v-5f33f45b] {
  margin-top: 0;
  margin-bottom: 1em;
}
.rich-text--wrapper-markdown h1[data-v-5f33f45b],
.rich-text--wrapper-markdown h2[data-v-5f33f45b],
.rich-text--wrapper-markdown h3[data-v-5f33f45b],
.rich-text--wrapper-markdown h4[data-v-5f33f45b],
.rich-text--wrapper-markdown h5[data-v-5f33f45b],
.rich-text--wrapper-markdown h6[data-v-5f33f45b] {
  font-weight: 700;
}
.rich-text--wrapper-markdown h1[data-v-5f33f45b] {
  font-size: 30px;
}
.rich-text--wrapper-markdown ul[data-v-5f33f45b],
.rich-text--wrapper-markdown ol[data-v-5f33f45b] {
  padding-left: 15px;
}
.rich-text--wrapper-markdown ul[data-v-5f33f45b] {
  list-style-type: disc;
}
.rich-text--wrapper-markdown blockquote[data-v-5f33f45b] {
  padding-left: 13px;
  border-left: 2px solid var(--color-border-dark);
  color: var(--color-text-lighter);
}
a[data-v-5f33f45b]:not(.rich-text--component) {
  text-decoration: underline;
}
.material-design-icon[data-v-cf695ff9],
.material-design-icon[data-v-9d850ea5] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.provider-list[data-v-9d850ea5] {
  width: 100%;
  min-height: 400px;
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
}
.provider-list--select[data-v-9d850ea5] {
  width: 100%;
}
.provider-list--select .provider[data-v-9d850ea5] {
  display: flex;
  align-items: center;
  height: 28px;
  overflow: hidden;
}
.provider-list--select .provider .link-icon[data-v-9d850ea5] {
  margin-right: 8px;
}
.provider-list--select .provider .provider-icon[data-v-9d850ea5] {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 8px;
  filter: var(--background-invert-if-dark);
}
.provider-list--select .provider .option-text[data-v-9d850ea5] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.material-design-icon[data-v-d0ba247a] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.raw-link[data-v-d0ba247a] {
  width: 100%;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 16px 16px;
}
.raw-link .input-wrapper[data-v-d0ba247a] {
  width: 100%;
}
.raw-link .reference-widget[data-v-d0ba247a] {
  display: flex;
}
.raw-link--empty-content .provider-icon[data-v-d0ba247a] {
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
}
.raw-link--input[data-v-d0ba247a] {
  width: 99%;
}
.material-design-icon[data-v-7a394a58] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.result[data-v-7a394a58] {
  display: flex;
  align-items: center;
  height: 44px;
  overflow: hidden;
}
.result--icon-class[data-v-7a394a58],
.result--image[data-v-7a394a58] {
  width: 40px;
  min-width: 40px;
  height: 40px;
  object-fit: contain;
}
.result--icon-class.rounded[data-v-7a394a58],
.result--image.rounded[data-v-7a394a58] {
  border-radius: 50%;
}
.result--content[data-v-7a394a58] {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
  overflow: hidden;
}
.result--content--name[data-v-7a394a58],
.result--content--subline[data-v-7a394a58] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.material-design-icon[data-v-97d196f0] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.smart-picker-search[data-v-97d196f0] {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
}
.smart-picker-search.with-empty-content[data-v-97d196f0] {
  min-height: 400px;
}
.smart-picker-search .provider-icon[data-v-97d196f0] {
  width: 150px;
  height: 150px;
  object-fit: contain;
  filter: var(--background-invert-if-dark);
}
.smart-picker-search--select[data-v-97d196f0],
.smart-picker-search--select .search-result[data-v-97d196f0] {
  width: 100%;
}
.smart-picker-search--select .group-name-icon[data-v-97d196f0],
.smart-picker-search--select .option-simple-icon[data-v-97d196f0] {
  width: 20px;
  height: 20px;
  margin: 0 20px 0 10px;
}
.smart-picker-search--select .custom-option[data-v-97d196f0] {
  height: 44px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.smart-picker-search--select .option-text[data-v-97d196f0] {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.material-design-icon[data-v-aa77d0d3] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker[data-v-aa77d0d3],
.reference-picker .custom-element-wrapper[data-v-aa77d0d3] {
  display: flex;
  overflow-y: auto;
  width: 100%;
}
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker-modal .modal-container {
  display: flex !important;
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-3f1a4ac7] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.reference-picker-modal--content[data-v-3f1a4ac7] {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
}
.reference-picker-modal--content .close-button[data-v-3f1a4ac7],
.reference-picker-modal--content .back-button[data-v-3f1a4ac7] {
  position: absolute;
  top: 4px;
}
.reference-picker-modal--content .back-button[data-v-3f1a4ac7] {
  left: 4px;
}
.reference-picker-modal--content .close-button[data-v-3f1a4ac7] {
  right: 4px;
}
.reference-picker-modal--content > h2[data-v-3f1a4ac7] {
  display: flex;
  margin: 12px 0 20px;
}
.reference-picker-modal--content > h2 .icon[data-v-3f1a4ac7] {
  margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/referencePickerModal-3a127978.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;EACb,oDAAoD;AACtD;AACA;EACE,WAAW;EACX,YAAY;EACZ,0DAA0D;EAC1D,uDAAuD;EACvD,gBAAgB;EAChB,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,wDAAwD;EACxD,2DAA2D;AAC7D;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oDAAoD;EACpD,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;AACA;EACE,8CAA8C;AAChD;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;;;;;;;;;;EAWE,aAAa;EACb,kBAAkB;AACpB;AACA;;;;;;EAME,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;;EAEE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;;EAEE,WAAW;AACb;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon[data-v-b1c5a80f] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widget-custom[data-v-b1c5a80f] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-large);\n  background-color: transparent;\n  display: flex;\n}\n.widget-access[data-v-b1c5a80f] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-large);\n  background-color: transparent;\n  display: flex;\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n}\n.widget-default[data-v-b1c5a80f] {\n  width: 100%;\n  margin: auto;\n  margin-bottom: calc(var(--default-grid-baseline, 4px) * 3);\n  margin-top: calc(var(--default-grid-baseline, 4px) * 3);\n  overflow: hidden;\n  border: 2px solid var(--color-border);\n  border-radius: var(--border-radius-large);\n  background-color: transparent;\n  display: flex;\n}\n.widget-default--compact[data-v-b1c5a80f] {\n  flex-direction: column;\n}\n.widget-default--compact .widget-default--image[data-v-b1c5a80f] {\n  width: 100%;\n  height: 150px;\n}\n.widget-default--compact .widget-default--details[data-v-b1c5a80f] {\n  width: 100%;\n  padding-top: calc(var(--default-grid-baseline, 4px) * 2);\n  padding-bottom: calc(var(--default-grid-baseline, 4px) * 2);\n}\n.widget-default--compact .widget-default--description[data-v-b1c5a80f] {\n  display: none;\n}\n.widget-default--image[data-v-b1c5a80f] {\n  width: 40%;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n.widget-default--name[data-v-b1c5a80f] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 700;\n}\n.widget-default--details[data-v-b1c5a80f] {\n  padding: calc(var(--default-grid-baseline, 4px) * 3);\n  width: 60%;\n}\n.widget-default--details p[data-v-b1c5a80f] {\n  margin: 0;\n  padding: 0;\n}\n.widget-default--description[data-v-b1c5a80f] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.widget-default--link[data-v-b1c5a80f] {\n  color: var(--color-text-maxcontrast);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.material-design-icon[data-v-bd1fbb02] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.widgets--list.icon-loading[data-v-bd1fbb02] {\n  min-height: 44px;\n}\n.material-design-icon[data-v-5f33f45b] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.rich-text--wrapper[data-v-5f33f45b] {\n  word-break: break-word;\n  line-height: 1.5;\n}\n.rich-text--wrapper .rich-text--fallback[data-v-5f33f45b],\n.rich-text--wrapper .rich-text-component[data-v-5f33f45b] {\n  display: inline;\n}\n.rich-text--wrapper .rich-text--external-link[data-v-5f33f45b] {\n  text-decoration: underline;\n}\n.rich-text--wrapper .rich-text--external-link[data-v-5f33f45b]:after {\n  content: \" ↗\";\n}\n.rich-text--wrapper .rich-text--ordered-list .rich-text--list-item[data-v-5f33f45b] {\n  list-style: decimal;\n}\n.rich-text--wrapper .rich-text--un-ordered-list .rich-text--list-item[data-v-5f33f45b] {\n  list-style: initial;\n}\n.rich-text--wrapper .rich-text--list-item[data-v-5f33f45b] {\n  white-space: initial;\n  color: var(--color-text-light);\n  padding: initial;\n  margin-left: 20px;\n}\n.rich-text--wrapper .rich-text--list-item.task-list-item[data-v-5f33f45b] {\n  list-style: none;\n  white-space: initial;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--list-item.task-list-item input[data-v-5f33f45b] {\n  min-height: initial;\n}\n.rich-text--wrapper .rich-text--strong[data-v-5f33f45b] {\n  white-space: initial;\n  font-weight: 700;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--italic[data-v-5f33f45b] {\n  white-space: initial;\n  font-style: italic;\n  color: var(--color-text-light);\n}\n.rich-text--wrapper .rich-text--heading[data-v-5f33f45b] {\n  white-space: initial;\n  font-size: initial;\n  color: var(--color-text-light);\n  margin-bottom: 5px;\n  margin-top: 5px;\n  font-weight: 700;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-1[data-v-5f33f45b] {\n  font-size: 20px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-2[data-v-5f33f45b] {\n  font-size: 19px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-3[data-v-5f33f45b] {\n  font-size: 18px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-4[data-v-5f33f45b] {\n  font-size: 17px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-5[data-v-5f33f45b] {\n  font-size: 16px;\n}\n.rich-text--wrapper .rich-text--heading.rich-text--heading-6[data-v-5f33f45b] {\n  font-size: 15px;\n}\n.rich-text--wrapper .rich-text--hr[data-v-5f33f45b] {\n  border-top: 1px solid var(--color-border-dark);\n  border-bottom: 0;\n}\n.rich-text--wrapper .rich-text--pre[data-v-5f33f45b] {\n  border: 1px solid var(--color-border-dark);\n  background-color: var(--color-background-dark);\n  padding: 5px;\n}\n.rich-text--wrapper .rich-text--code[data-v-5f33f45b] {\n  background-color: var(--color-background-dark);\n}\n.rich-text--wrapper .rich-text--blockquote[data-v-5f33f45b] {\n  border-left: 3px solid var(--color-border-dark);\n  padding-left: 5px;\n}\n.rich-text--wrapper .rich-text--table[data-v-5f33f45b] {\n  border-collapse: collapse;\n}\n.rich-text--wrapper .rich-text--table thead tr th[data-v-5f33f45b] {\n  border: 1px solid var(--color-border-dark);\n  font-weight: 700;\n  padding: 6px 13px;\n}\n.rich-text--wrapper .rich-text--table tbody tr td[data-v-5f33f45b] {\n  border: 1px solid var(--color-border-dark);\n  padding: 6px 13px;\n}\n.rich-text--wrapper .rich-text--table tbody tr[data-v-5f33f45b]:nth-child(even) {\n  background-color: var(--color-background-dark);\n}\n.rich-text--wrapper-markdown div > *[data-v-5f33f45b]:first-child,\n.rich-text--wrapper-markdown blockquote > *[data-v-5f33f45b]:first-child {\n  margin-top: 0 !important;\n}\n.rich-text--wrapper-markdown div > *[data-v-5f33f45b]:last-child,\n.rich-text--wrapper-markdown blockquote > *[data-v-5f33f45b]:last-child {\n  margin-bottom: 0 !important;\n}\n.rich-text--wrapper-markdown h1[data-v-5f33f45b],\n.rich-text--wrapper-markdown h2[data-v-5f33f45b],\n.rich-text--wrapper-markdown h3[data-v-5f33f45b],\n.rich-text--wrapper-markdown h4[data-v-5f33f45b],\n.rich-text--wrapper-markdown h5[data-v-5f33f45b],\n.rich-text--wrapper-markdown h6[data-v-5f33f45b],\n.rich-text--wrapper-markdown p[data-v-5f33f45b],\n.rich-text--wrapper-markdown ul[data-v-5f33f45b],\n.rich-text--wrapper-markdown ol[data-v-5f33f45b],\n.rich-text--wrapper-markdown blockquote[data-v-5f33f45b],\n.rich-text--wrapper-markdown pre[data-v-5f33f45b] {\n  margin-top: 0;\n  margin-bottom: 1em;\n}\n.rich-text--wrapper-markdown h1[data-v-5f33f45b],\n.rich-text--wrapper-markdown h2[data-v-5f33f45b],\n.rich-text--wrapper-markdown h3[data-v-5f33f45b],\n.rich-text--wrapper-markdown h4[data-v-5f33f45b],\n.rich-text--wrapper-markdown h5[data-v-5f33f45b],\n.rich-text--wrapper-markdown h6[data-v-5f33f45b] {\n  font-weight: 700;\n}\n.rich-text--wrapper-markdown h1[data-v-5f33f45b] {\n  font-size: 30px;\n}\n.rich-text--wrapper-markdown ul[data-v-5f33f45b],\n.rich-text--wrapper-markdown ol[data-v-5f33f45b] {\n  padding-left: 15px;\n}\n.rich-text--wrapper-markdown ul[data-v-5f33f45b] {\n  list-style-type: disc;\n}\n.rich-text--wrapper-markdown blockquote[data-v-5f33f45b] {\n  padding-left: 13px;\n  border-left: 2px solid var(--color-border-dark);\n  color: var(--color-text-lighter);\n}\na[data-v-5f33f45b]:not(.rich-text--component) {\n  text-decoration: underline;\n}\n.material-design-icon[data-v-cf695ff9],\n.material-design-icon[data-v-9d850ea5] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.provider-list[data-v-9d850ea5] {\n  width: 100%;\n  min-height: 400px;\n  padding: 0 16px 16px;\n  display: flex;\n  flex-direction: column;\n}\n.provider-list--select[data-v-9d850ea5] {\n  width: 100%;\n}\n.provider-list--select .provider[data-v-9d850ea5] {\n  display: flex;\n  align-items: center;\n  height: 28px;\n  overflow: hidden;\n}\n.provider-list--select .provider .link-icon[data-v-9d850ea5] {\n  margin-right: 8px;\n}\n.provider-list--select .provider .provider-icon[data-v-9d850ea5] {\n  width: 20px;\n  height: 20px;\n  object-fit: contain;\n  margin-right: 8px;\n  filter: var(--background-invert-if-dark);\n}\n.provider-list--select .provider .option-text[data-v-9d850ea5] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.material-design-icon[data-v-d0ba247a] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.raw-link[data-v-d0ba247a] {\n  width: 100%;\n  min-height: 350px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  padding: 0 16px 16px;\n}\n.raw-link .input-wrapper[data-v-d0ba247a] {\n  width: 100%;\n}\n.raw-link .reference-widget[data-v-d0ba247a] {\n  display: flex;\n}\n.raw-link--empty-content .provider-icon[data-v-d0ba247a] {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n}\n.raw-link--input[data-v-d0ba247a] {\n  width: 99%;\n}\n.material-design-icon[data-v-7a394a58] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.result[data-v-7a394a58] {\n  display: flex;\n  align-items: center;\n  height: 44px;\n  overflow: hidden;\n}\n.result--icon-class[data-v-7a394a58],\n.result--image[data-v-7a394a58] {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n.result--icon-class.rounded[data-v-7a394a58],\n.result--image.rounded[data-v-7a394a58] {\n  border-radius: 50%;\n}\n.result--content[data-v-7a394a58] {\n  display: flex;\n  flex-direction: column;\n  padding-left: 10px;\n  overflow: hidden;\n}\n.result--content--name[data-v-7a394a58],\n.result--content--subline[data-v-7a394a58] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.material-design-icon[data-v-97d196f0] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.smart-picker-search[data-v-97d196f0] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 0 16px 16px;\n}\n.smart-picker-search.with-empty-content[data-v-97d196f0] {\n  min-height: 400px;\n}\n.smart-picker-search .provider-icon[data-v-97d196f0] {\n  width: 150px;\n  height: 150px;\n  object-fit: contain;\n  filter: var(--background-invert-if-dark);\n}\n.smart-picker-search--select[data-v-97d196f0],\n.smart-picker-search--select .search-result[data-v-97d196f0] {\n  width: 100%;\n}\n.smart-picker-search--select .group-name-icon[data-v-97d196f0],\n.smart-picker-search--select .option-simple-icon[data-v-97d196f0] {\n  width: 20px;\n  height: 20px;\n  margin: 0 20px 0 10px;\n}\n.smart-picker-search--select .custom-option[data-v-97d196f0] {\n  height: 44px;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n.smart-picker-search--select .option-text[data-v-97d196f0] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.material-design-icon[data-v-aa77d0d3] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker[data-v-aa77d0d3],\n.reference-picker .custom-element-wrapper[data-v-aa77d0d3] {\n  display: flex;\n  overflow-y: auto;\n  width: 100%;\n}\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker-modal .modal-container {\n  display: flex !important;\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-3f1a4ac7] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.reference-picker-modal--content[data-v-3f1a4ac7] {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow-y: auto;\n}\n.reference-picker-modal--content .close-button[data-v-3f1a4ac7],\n.reference-picker-modal--content .back-button[data-v-3f1a4ac7] {\n  position: absolute;\n  top: 4px;\n}\n.reference-picker-modal--content .back-button[data-v-3f1a4ac7] {\n  left: 4px;\n}\n.reference-picker-modal--content .close-button[data-v-3f1a4ac7] {\n  right: 4px;\n}\n.reference-picker-modal--content > h2[data-v-3f1a4ac7] {\n  display: flex;\n  margin: 12px 0 20px;\n}\n.reference-picker-modal--content > h2 .icon[data-v-3f1a4ac7] {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
